import React from 'react'
import {find, propEq} from 'ramda'
import {CheckboxFilterForm, Row, Col} from '@modifi/ui'

import Filter, {CommonFilterProps, FilterOption} from '../../ui/filter'

export type StatusFilterProps = CommonFilterProps & {
  filterKey: string
  options: FilterOption[]
}

const StatusFilter: React.FC<StatusFilterProps> = ({filterKey, options, ...restFilterProps}) => {
  const findOption = (value: string) => find(propEq('value', value), options)

  const getDefaultParams = (search: Record<string, any>) => ({
    defaultSelected: search[filterKey] ? search[filterKey].map(findOption) : [],
  })

  const getSearchParams = (selected: FilterOption[]) => ({
    [filterKey]: selected.map(({value}) => value),
  })

  return (
    <Row>
      <Col>
        <Filter
          filterComponent={CheckboxFilterForm}
          options={options}
          getDefaultParams={getDefaultParams}
          getSearchParams={getSearchParams}
          {...restFilterProps}
        />
      </Col>
    </Row>
  )
}

export default StatusFilter
